// extracted by mini-css-extract-plugin
export var animationAbsolute = "_1x-q";
export var animationRelative = "_1x-p";
export var backdropBlur = "_1x-0";
export var detailLabelCell = "_1x-12";
export var detailTable = "_1x-11";
export var detailValueCell = "_1x-13";
export var docIconBox = "_1x-1d";
export var docIconBoxMd = "_1x-1f";
export var docIconBoxSm = "_1x-1e";
export var docTypeRow = "_1x-16";
export var docTypeRowInner = "_1x-17";
export var dropdownMatchDatePicker = "_1x-3";
export var evidenceCardContent = "_1x-1c";
export var fileUploadSpin = "_1x-j";
export var gorgiasOpenButton = "_1x-15 _1x-d";
export var gorgiasTicketCard = "_1x-14";
export var heroModalFooterButton = "_1x-18";
export var hiddenContainer = "_1x-o";
export var iconPrimary = "_1x-1g";
export var iconSecondary = "_1x-1h";
export var iconTertiary = "_1x-1i";
export var integrationCard = "_1x-1";
export var integrationLogoBox = "_1x-2";
export var mainColumnSticky = "_1x-1b";
export var maxWidthContainer = "_1x-19";
export var modalContentBody = "_1x-a";
export var modalHeaderImage = "_1x-5";
export var modalImageLabel = "_1x-7";
export var modalImageOverlay = "_1x-6";
export var modalImageSubtitle = "_1x-9";
export var modalImageTitle = "_1x-8";
export var modalImageWrapper = "_1x-4";
export var modalStickyFooter = "_1x-b";
export var removeButton = "_1x-e";
export var sidebarColumn = "_1x-1a";
export var spinner = "_1x-i";
export var timelineLine = "_1x-y";
export var timelineLineBlack = "_1x-10 _1x-y";
export var timelineLineGray = "_1x-z _1x-y";
export var timelineLineHeight = "_1x-x";
export var tlDotActivate = "_1x-u";
export var tlDotActivateAnim = "_1x-t";
export var tlDotHide = "_1x-s";
export var tlDotHideAnim = "_1x-r";
export var tlLineActivate = "_1x-w";
export var tlLineActivateAnim = "_1x-v";
export var uploadHint = "_1x-n";
export var uploadIconBox = "_1x-k";
export var uploadLabel = "_1x-m";
export var uploadText = "_1x-l";
export var uploadZone = "_1x-f";
export var uploadZoneCursorDefault = "_1x-h";
export var uploadZoneCursorPointer = "_1x-g";
export var uploadedFileRow = "_1x-c";
export var viewButton = "_1x-d";